import React from "react";
import ReactDOM from "react-dom";
import DonationProvider from "./components/DonationProvider";
import DonationForm from "./components/DonationForm";
import DonationTable from "./components/DonationTable";

const ELEMENTS_MAPPING = {
    DonationForm,
    DonationTable,
};

const generateElementConfig = (Element, wrapperProps = {}) => {
    return {
        mount: (target, props) => {
            ReactDOM.render(
                <DonationProvider {...wrapperProps}>
                    <Element {...props} />
                </DonationProvider>,
                document.querySelector(target)
            );
        },
    };
};

const Elements = (appId) => {
    return Object.entries(ELEMENTS_MAPPING).reduce((prev, entry) => {
        prev[entry[0]] = generateElementConfig(entry[1], appId);
        return prev;
    }, {});
};

export default Elements;
